import {
	Component,
	OnInit,
	Renderer2,
	HostListener,
	ViewChild,
	ElementRef,
	AfterViewInit,
} from '@angular/core';
import { Route, Router } from '@angular/router';
import { environment } from '../../environments/environment';
// import lottie from '../../assets/js/lottie';
import { PageService } from '../providers/page/page.service';
import { Meta, Title } from '@angular/platform-browser';
//  
import { SpinalThreeService } from '../providers/SplineThree/spinal-three.service';
 

@Component({
	selector: 'app-services',
	templateUrl: './services.component.html',
	styleUrls: ['./services.component.scss'],
})
export class ServicesComponent implements OnInit {
	baseUrl: any;
	isPlaying = true;
	spline: any;
	clientImgarray: any = [];
	filteredClients: any = [];
	isChangingRandom = false;
	intervalId: any;
	@ViewChild('canvas', { static: true })
	containerRef!: ElementRef<HTMLDivElement>;
	constructor(
		public router: Router,
		private pageservice: PageService,
		private metaTagService: Meta,
		private titleService: Title,
		private splineThreeService: SpinalThreeService
	) {
		this.get_PageMeta();
		this.baseUrl = environment.baseUrl + '/assets';
	}

	onScroll(event: Event): void {
		if (this.spline) {
			this.spline.setZoom(1, 1);
		}
	}

	ngOnInit() {

		// const canvas = document.getElementById('canvas') as HTMLCanvasElement;
		// this.spline = new Application(canvas);
		// this.spline.load(
		// 	'https://prod.spline.design/ETc1NgtkFiSuPoFT/scene.splinecode'
		// );
		if (this.containerRef && this.containerRef.nativeElement) {
			const container = this.containerRef.nativeElement;
			this.splineThreeService.initialize(
				container,
				'https://prod.spline.design/ETc1NgtkFiSuPoFT/scene.splinecode'
			);
		}
		
		var animationData = {
			v: '5.9.6',
			fr: 30,
			ip: 0,
			op: 96,
			w: 122,
			h: 119,
			nm: 'hand',
			ddd: 0,
			assets: [],
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 3,
					nm: 'Null 1',
					sr: 1,
					ks: {
						o: { a: 0, k: 0, ix: 11 },
						r: { a: 0, k: -34.9, ix: 10 },
						p: { a: 0, k: [67.1, 111.5, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					ip: 0,
					op: 150,
					st: 0,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'Layer 3 Outlines',
					parent: 1,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: {
							a: 1,
							k: [
								{
									i: { x: [0.667], y: [1] },
									o: { x: [0.333], y: [0] },
									t: 0,
									s: [0],
								},
								{
									i: { x: [0.667], y: [1] },
									o: { x: [0.333], y: [0] },
									t: 9.546,
									s: [8],
								},
								{
									i: { x: [0.667], y: [1] },
									o: { x: [0.333], y: [0] },
									t: 20.363,
									s: [-8],
								},
								{
									i: { x: [0.65], y: [1.156] },
									o: { x: [0.333], y: [0] },
									t: 30.546,
									s: [8],
								},
								{
									i: { x: [0.667], y: [1] },
									o: { x: [0.167], y: [0] },
									t: 42,
									s: [-1.8],
								},
								{
									i: { x: [0.833], y: [1] },
									o: { x: [0.333], y: [0] },
									t: 51,
									s: [0],
								},
								{
									i: { x: [0.833], y: [1] },
									o: { x: [0.167], y: [0] },
									t: 60,
									s: [-0.4],
								},
								{ t: 69, s: [0] },
							],
							ix: 10,
						},
						p: { a: 0, k: [-2.981, 0.359, 0], ix: 2, l: 2 },
						a: {
							a: 1,
							k: [
								{
									i: { x: 0.833, y: 0.833 },
									o: { x: 0.167, y: 0.167 },
									t: 0,
									s: [15.024, 91.188, 0],
									to: [0, 0, 0],
									ti: [0, 0, 0],
								},
								{ t: 44, s: [15.024, 91.188, 0] },
							],
							ix: 1,
							l: 2,
						},
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
												[3.903, -5.533],
												[3.056, -2.353],
												[6.543, 2.313],
												[4.228, 4.252],
												[0.327, 6.566],
												[-0.109, 2.842],
												[-0.281, 9.016],
												[0.083, 2.706],
												[-1.043, 0.386],
												[-0.666, -2.038],
												[-0.181, -1.13],
												[0.156, -4.374],
												[-1.579, -0.706],
												[-1.31, 1],
												[-0.442, 0.663],
												[-6.815, 9.598],
												[-0.455, 0.427],
												[-1.272, -1.478],
												[1.046, -1.327],
												[4.713, -6.619],
												[0.196, -0.327],
												[-1.1, -0.992],
												[-1.181, 0.832],
												[-0.345, 0.518],
												[-6.936, 9.765],
												[-0.29, 0.345],
												[-1.763, -0.582],
												[-0.03, -1.826],
												[0.764, -0.91],
												[6.934, -9.766],
												[0.241, -0.499],
												[-1.104, -0.867],
												[-1.126, 0.839],
												[-0.321, 0.495],
												[-5.124, 7.179],
												[-0.342, 0.391],
												[-1.712, -0.819],
												[1.17, -2.201],
												[0.133, -0.179],
												[5.282, -7.492],
												[-1.55, -1.123],
												[-1.373, 1.933],
												[-2.975, 4.189],
												[-0.217, 0.273],
												[-1.064, -0.33],
												[-0.164, -0.992],
												[0.618, -0.721],
												[4.295, -6.063],
											],
											o: [
												[0, 0],
												[-3.925, 5.53],
												[-2.207, 3.163],
												[-5.419, 4.144],
												[-5.658, -1.985],
												[-4.757, -4.537],
												[-0.132, -2.83],
												[0.352, -9.013],
												[0.084, -2.7],
												[-0.047, -1.53],
												[2.052, -0.622],
												[0.282, 1.109],
												[0.785, 4.306],
												[-0.141, 1.724],
												[1.431, 0.818],
												[0.627, -0.491],
												[6.837, -9.584],
												[0.339, -0.524],
												[1.477, -1.272],
												[1.103, 1.28],
												[-4.699, 6.627],
												[-0.221, 0.311],
												[-0.761, 1.271],
												[1.062, 0.978],
												[0.484, -0.392],
												[6.95, -9.758],
												[0.262, -0.368],
												[1.202, -1.415],
												[1.726, 0.596],
												[-0.023, 1.188],
												[-6.946, 9.76],
												[-0.333, 0.444],
												[-0.56, 1.287],
												[1.107, 0.863],
												[0.438, -0.395],
												[5.133, -7.171],
												[0.3, -0.423],
												[1.273, -1.408],
												[2.2, 1.171],
												[-0.105, 0.197],
												[-5.348, 7.451],
												[-1.34, 1.9],
												[1.55, 1.123],
												[2.98, -4.187],
												[0.2, -0.283],
												[0.669, -0.891],
												[0.979, 0.23],
												[0.17, 0.934],
												[-4.32, 6.046],
												[0, 0],
											],
											v: [
												[23.152, 14.265],
												[23.152, 14.265],
												[11.387, 30.834],
												[3.446, 39.158],
												[-14.469, 42.324],
												[-29.49, 32.847],
												[-37.41, 15.555],
												[-37.109, 7.033],
												[-36.085, -20.008],
												[-36.314, -28.124],
												[-34.842, -30.943],
												[-29.951, -28.395],
												[-29.245, -25.033],
												[-28.298, -11.975],
												[-25.898, -7.919],
												[-21.376, -8.219],
												[-19.764, -9.962],
												[0.715, -38.734],
												[1.91, -40.165],
												[6.888, -39.794],
												[6.986, -35.305],
												[-7.133, -15.436],
												[-7.783, -14.492],
												[-7.199, -10.598],
												[-3.355, -10.348],
												[-2.105, -11.721],
												[18.725, -41.005],
												[19.531, -42.094],
												[24.437, -43.471],
												[27.362, -39.438],
												[26.146, -36.195],
												[5.327, -6.906],
												[4.464, -5.488],
												[5.387, -1.83],
												[9.168, -1.788],
												[10.311, -3.128],
												[25.697, -24.654],
												[26.645, -25.895],
												[31.676, -26.887],
												[33.542, -20.783],
												[33.185, -20.219],
												[17.314, 2.245],
												[17.658, 7.111],
												[22.458, 5.811],
												[31.391, -6.755],
												[32.008, -7.593],
												[34.898, -8.527],
												[36.785, -6.509],
												[36.077, -3.893],
												[23.154, 14.271],
											],
											c: false,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ind: 1,
									ty: 'sh',
									ix: 2,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[-2.092, -1],
												[-5.851, 1.244],
												[-2.89, 2.122],
												[-2.836, 4.038],
												[-8.223, 11.534],
												[1.8, 3.179],
												[2.203, 0.713],
												[-0.482, 0.692],
												[3.481, 3.721],
												[1.699, 0.527],
												[0.484, 0.17],
												[1.139, 3.155],
												[2.122, 1.241],
												[3.015, -1.109],
												[1.758, -2.785],
												[0.644, 0.543],
												[3.548, -4.034],
												[0.13, -0.169],
												[1.792, -2.514],
												[4.079, -5.747],
												[0, 0],
												[0.082, 0.492],
												[0.844, 3.567],
												[3.743, 0.857],
												[2.2, -2.689],
												[-0.104, -2.042],
												[0.639, -12.849],
												[-1.281, -4.26],
												[-5.078, -4.319],
												[-0.195, -0.238],
												[0, 0],
											],
											o: [
												[2.036, 1.113],
												[5.3, 2.515],
												[3.508, -0.744],
												[3.984, -2.911],
												[8.184, -11.562],
												[2.279, -2.855],
												[-1.124, -2.024],
												[0.544, -0.765],
												[3.017, -4.106],
												[-1.184, -1.328],
												[-0.386, -0.124],
												[1.837, -2.807],
												[-0.767, -2.335],
												[-2.755, -1.652],
												[-3.194, 1.082],
												[-0.671, -0.678],
												[-4.034, -3.548],
												[-0.141, 0.16],
												[-1.912, 2.423],
												[-4.089, 5.741],
												[0, 0],
												[-0.08, -0.81],
												[-0.575, -3.63],
												[-0.905, -3.835],
												[-3.335, -0.972],
												[-1.354, 1.532],
												[0.755, 12.89],
												[-0.219, 4.4],
												[1.914, 6.386],
												[0.221, 0.214],
												[0, 0],
												[0, 0],
											],
											v: [
												[-26.227, 43.472],
												[-20.111, 46.795],
												[-3.436, 49.195],
												[6.271, 44.847],
												[16.572, 34.353],
												[41.182, -0.292],
												[41.975, -10.279],
												[36.799, -14.538],
												[38.319, -16.68],
												[37.519, -30.18],
												[33.112, -33.014],
												[31.862, -33.451],
												[32.969, -42.919],
												[28.486, -48.471],
												[19.361, -49.329],
												[12.486, -42.977],
												[10.62, -44.85],
												[-3.107, -43.971],
												[-3.514, -43.477],
												[-8.939, -35.964],
												[-21.189, -18.731],
												[-22.033, -17.546],
												[-22.214, -19.346],
												[-24.014, -30.219],
												[-31.486, -37.094],
												[-40.613, -34.262],
												[-42.563, -28.686],
												[-43.555, 9.895],
												[-42.488, 22.887],
												[-31.775, 39.287],
												[-31.152, 39.965],
												[-26.227, 43.465],
											],
											c: false,
										},
										ix: 2,
									},
									nm: 'Path 2',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'mm',
									mm: 1,
									nm: 'Merge Paths 1',
									mn: 'ADBE Vector Filter - Merge',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.854902020623, 0.588235294118, 0.466666696586, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [44.024, 50.688], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Group 1',
							np: 4,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 150,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 4,
					nm: 'Layer 4 Outlines',
					parent: 1,
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.667], y: [1] },
									o: { x: [0.333], y: [0] },
									t: 3.182,
									s: [4],
								},
								{ t: 17, s: [100] },
							],
							ix: 11,
						},
						r: { a: 0, k: 0, ix: 10 },
						p: {
							s: true,
							x: {
								a: 1,
								k: [
									{
										i: { x: [0.591], y: [1.232] },
										o: { x: [0.333], y: [0] },
										t: 3.182,
										s: [64.512],
									},
									{ t: 17, s: [78.762] },
								],
								ix: 3,
							},
							y: {
								a: 1,
								k: [
									{
										i: { x: [0.667], y: [1] },
										o: { x: [0.333], y: [0] },
										t: 3.182,
										s: [-46.004],
									},
									{ t: 17, s: [-45.754] },
								],
								ix: 4,
							},
						},
						a: { a: 0, k: [3.602, 10.311, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[-0.001, 0.462],
												[-0.098, 0.14],
												[0.05, 0.08],
												[-0.397, 0.235],
												[-0.245, -0.372],
												[-0.243, -2.031],
												[2.88, -3.875],
												[0.273, 0],
											],
											o: [
												[-0.461, 0],
												[0, -0.17],
												[6.552, -9.387],
												[-0.235, -0.397],
												[0.383, -0.227],
												[1.001, 1.784],
												[0.576, 4.793],
												[-0.156, 0.224],
												[0, 0],
											],
											v: [
												[-2.516, 10.057],
												[-3.351, 9.221],
												[-3.201, 8.745],
												[-1.542, -8.689],
												[-1.249, -9.834],
												[-0.128, -9.576],
												[1.757, -3.797],
												[-1.831, 9.704],
												[-2.516, 10.061],
											],
											c: false,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.854902020623, 0.588235294118, 0.466666696586, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [3.601, 10.311], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Group 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 150,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'Layer 5 Outlines',
					parent: 1,
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.667], y: [1] },
									o: { x: [0.333], y: [0] },
									t: 0,
									s: [0],
								},
								{ t: 15, s: [100] },
							],
							ix: 11,
						},
						r: {
							a: 1,
							k: [
								{
									i: { x: [0.667], y: [1] },
									o: { x: [0.333], y: [0] },
									t: 0,
									s: [0],
								},
								{ t: 15, s: [0] },
							],
							ix: 10,
						},
						p: {
							s: true,
							x: {
								a: 1,
								k: [
									{
										i: { x: [0.524], y: [1.943] },
										o: { x: [0.333], y: [0] },
										t: 0,
										s: [63.218],
									},
									{ t: 15, s: [81.718] },
								],
								ix: 3,
							},
							y: {
								a: 1,
								k: [
									{
										i: { x: [0.667], y: [1] },
										o: { x: [0.333], y: [0] },
										t: 0,
										s: [-46.437],
									},
									{ t: 15, s: [-45.687] },
								],
								ix: 4,
							},
						},
						a: { a: 0, k: [3.592, 13.05, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[-0.001, 0.462],
												[-0.098, 0.14],
												[0.719, 5.523],
												[1.159, 2.111],
												[-0.394, 0.238],
												[-0.245, -0.379],
												[-0.31, -2.601],
												[4.815, -6.892],
												[0.273, 0],
											],
											o: [
												[-0.461, 0],
												[0, -0.17],
												[3.6, -5.154],
												[-0.281, -2.392],
												[-0.238, -0.395],
												[0.387, -0.233],
												[1.281, 2.285],
												[0.55, 4.109],
												[-0.156, 0.224],
												[0, 0],
											],
											v: [
												[-2.507, 12.799],
												[-3.341, 11.964],
												[-3.191, 11.486],
												[1.147, -4.604],
												[-1.033, -11.421],
												[-0.75, -12.566],
												[0.383, -12.305],
												[2.792, -4.905],
												[-1.823, 12.439],
												[-2.508, 12.797],
											],
											c: false,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.854902020623, 0.588235294118, 0.466666696586, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [3.592, 13.05], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Group 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 150,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 4,
					nm: 'Layer 6 Outlines',
					parent: 1,
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.667], y: [1] },
									o: { x: [0.333], y: [0] },
									t: 15.909,
									s: [3],
								},
								{ t: 28, s: [100] },
							],
							ix: 11,
						},
						r: { a: 0, k: 0, ix: 10 },
						p: {
							s: true,
							x: {
								a: 1,
								k: [
									{
										i: { x: [0.706], y: [1.553] },
										o: { x: [0.333], y: [0] },
										t: 15.909,
										s: [30.436],
									},
									{ t: 28, s: [24.186] },
								],
								ix: 3,
							},
							y: {
								a: 1,
								k: [
									{
										i: { x: [0.652], y: [1.489] },
										o: { x: [0.333], y: [0] },
										t: 15.909,
										s: [-81.209],
									},
									{ t: 28, s: [-93.959] },
								],
								ix: 4,
							},
						},
						a: { a: 0, k: [9.646, 4.948, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[-0.001, 0.461],
												[-0.075, 0.128],
												[-1.692, 1.15],
												[-4.764, -0.772],
												[0.06, -0.457],
												[0.457, 0.06],
												[3.634, -2.451],
												[1.022, -1.522],
												[0.295, 0],
											],
											o: [
												[-0.461, -0.001],
												[0, -0.148],
												[1.123, -1.71],
												[3.99, -2.716],
												[0.457, 0.06],
												[-0.06, 0.457],
												[-4.324, -0.717],
												[-1.519, 1.027],
												[-0.151, 0.253],
												[0, 0],
											],
											v: [
												[-8.561, 4.693],
												[-9.395, 3.855],
												[-9.279, 3.435],
												[-5.016, -0.898],
												[8.617, -3.926],
												[9.335, -2.989],
												[8.398, -2.27],
												[-3.995, 0.431],
												[-7.842, 4.29],
												[-8.561, 4.698],
											],
											c: false,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.854902020623, 0.588235294118, 0.466666696586, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [9.645, 4.948], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Group 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 150,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 6,
					ty: 4,
					nm: 'Layer 7 Outlines',
					parent: 1,
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.667], y: [1] },
									o: { x: [0.333], y: [0] },
									t: 13.363,
									s: [0],
								},
								{ t: 26, s: [100] },
							],
							ix: 11,
						},
						r: { a: 0, k: 0, ix: 10 },
						p: {
							s: true,
							x: {
								a: 1,
								k: [
									{
										i: { x: [0.624], y: [2.994] },
										o: { x: [0.333], y: [0] },
										t: 13.363,
										s: [30.021],
									},
									{ t: 26, s: [22.771] },
								],
								ix: 3,
							},
							y: {
								a: 1,
								k: [
									{
										i: { x: [0.624], y: [1.964] },
										o: { x: [0.333], y: [0] },
										t: 13.363,
										s: [-82.012],
									},
									{ t: 26, s: [-97.012] },
								],
								ix: 4,
							},
						},
						a: { a: 0, k: [12.19, 6.146, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0.295, 0],
												[0, 0.461],
												[-0.076, 0.128],
												[-2.168, 1.472],
												[-8.332, -1.099],
												[0.06, -0.457],
												[0.457, 0.06],
												[4.573, -3.179],
												[1.34, -2],
											],
											o: [
												[-0.461, -0.001],
												[0.001, -0.149],
												[1.439, -2.19],
												[3.394, -2.379],
												[0.457, 0.06],
												[-0.06, 0.457],
												[-6.231, -0.82],
												[-1.994, 1.35],
												[-0.151, 0.254],
											],
											v: [
												[-11.106, 5.895],
												[-11.94, 5.059],
												[-11.824, 4.637],
												[-6.361, -0.91],
												[11.161, -4.796],
												[11.88, -3.859],
												[10.943, -3.14],
												[-5.339, 0.413],
												[-10.387, 5.486],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.854902020623, 0.588235294118, 0.466666696586, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [12.19, 6.146], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Group 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 150,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
			markers: [],
		};
		import('../../assets/js/lottie').then(lottieModule => {
			const params = {
				container: document.getElementById('lottie'),
				renderer: 'svg',
				loop: true,
				autoplay: true,
				animationData: animationData, 
			};
	
			lottieModule.default.loadAnimation(params);
		});
		let urlTree = this.router.parseUrl(this.router.url);
		if (!urlTree.fragment) {
			// window.scroll(0,0);
			setTimeout(() => {
				window.scroll({
					top: 0,
					left: 0,
					behavior: 'smooth',
				});
			}, 500);
		}
		// setTimeout(() => {
		//   const canvas = document.getElementById('canvas') as HTMLCanvasElement;
		// this.spline = new Application(canvas);
		// this.spline.load('https://prod.spline.design/ETc1NgtkFiSuPoFT/scene.splinecode');
		// }, 500);
		this.clientImgarray.push(
			{ id: 1, img: this.baseUrl + '/img/home/logos/dnour.svg', class: '' },
			{ id: 2, img: this.baseUrl + '/img/home/logos/crystal.svg', class: '' },
			{ id: 3, img: this.baseUrl + '/img/home/logos/miniaar.svg', class: '' },
			// { id: 4, img: this.baseUrl + "/img/home/logos/bni.svg", class:'' },
			{ id: 5, img: this.baseUrl + '/img/home/logos/angle.svg' },
			{ id: 6, img: this.baseUrl + '/img/home/logos/pakhis.svg', class: '' },
			{ id: 7, img: this.baseUrl + '/img/home/logos/drminnie.svg', class: '' },
			{ id: 8, img: this.baseUrl + '/img/home/logos/veddentta.svg', class: '' },
			{
				id: 9,
				img: this.baseUrl + '/img/home/logos/autokoorosh.svg',
				class: '',
			},
			{ id: 10, img: this.baseUrl + '/img/home/logos/fractal.svg', class: '' },
			{
				id: 11,
				img: this.baseUrl + '/img/home/logos/corporate.svg',
				class: '',
			},
			{ id: 12, img: this.baseUrl + '/img/home/logos/aetrio.svg', class: '' },
			{ id: 13, img: this.baseUrl + '/img/home/logos/wrae.svg', class: '' },
			{ id: 14, img: this.baseUrl + '/img/home/logos/beyou.svg', class: '' },
			{
				id: 15,
				img: this.baseUrl + '/img/home/logos/alchemative.svg',
				class: '',
			},
			{ id: 16, img: this.baseUrl + '/img/home/logos/Asset 13.svg', class: '' },
			{
				id: 17,
				img: this.baseUrl + '/img/home/logos/caratcraft.svg',
				class: '',
			},
			{ id: 18, img: this.baseUrl + '/img/home/logos/ep.svg', class: '' },
			{
				id: 19,
				img: this.baseUrl + '/img/home/logos/holidaymate.svg',
				class: '',
			},
			{ id: 20, img: this.baseUrl + '/img/home/logos/j.avenue.svg', class: '' },
			// { id: 21, img: this.baseUrl + "/img/home/logos/jwarashri.svg", class:'' },
			{
				id: 22,
				img: this.baseUrl + '/img/home/logos/maney-angel.svg',
				class: '',
			},
			{
				id: 23,
				img: this.baseUrl + '/img/home/logos/santosh-kotli.svg',
				class: '',
			},
			{
				id: 24,
				img: this.baseUrl + '/img/home/logos/solitaire-events.svg',
				class: '',
			},
			{ id: 25, img: this.baseUrl + '/img/home/logos/spacex.svg', class: '' },
			{
				id: 26,
				img: this.baseUrl + '/img/home/logos/urban-excellence.svg',
				class: '',
			},
			{
				id: 27,
				img: this.baseUrl + '/img/home/logos/virtual-key.svg',
				class: '',
			},
			{ id: 28, img: this.baseUrl + '/img/home/logos/zlk.svg', class: '' }
		);
		this.filteredClients = this.clientImgarray.slice(0, 15);
		this.onHover();

		
		
	}
	ngAfterViewInit() {}

	onHover() {
		if (!this.isChangingRandom) {
			this.isChangingRandom = true;
			this.intervalId = setInterval(() => {
				this.filterClients();
			}, 2000);
		}
	}

	filterClients() {
		this.filteredClients.forEach((cl) => {
			cl.class = '';
		});
		let notvisibleClients = this.clientImgarray;
		let randomClients = [];
		for (var i = 0; i < 2; i++) {
			var idx = Math.floor(Math.random() * notvisibleClients.length);
			let tempRandom = randomClients.filter((cl) => cl.id == idx);
			if (tempRandom.length == 0) {
				randomClients.push(notvisibleClients[idx]);
			}
		}
		for (var j = 0; j < randomClients.length; j++) {
			let tempRandom = this.filteredClients.filter(
				(cl) => cl.id == randomClients[j].id
			);
			if (tempRandom.length == 0) {
				var idy = Math.floor(Math.random() * this.filteredClients.length);
				this.filteredClients[idy] = randomClients[j];
				this.filteredClients[idy].class = 'blur';
			}
		}
	}

	get_PageMeta() {
		let obj = { pageName: 'services' };
		this.pageservice.getpageWithName(obj).subscribe((response) => {
			if (response.body.code == 200) {
				if (response.body.result) {
					this.titleService.setTitle(response?.body.result.meta_title);
					// this.metaTagService.addTags([
					//     { name: 'description', content: response?.body.result.meta_description },
					//     { name: 'keywords', content: response?.body.result.meta_keywords },
					// ]);
					this.metaTagService.updateTag({
						name: 'description',
						content: response?.body.result.meta_description,
					});
					this.metaTagService.updateTag({
						name: 'keywords',
						content: response?.body.result.meta_keywords,
					});
					this.metaTagService.updateTag({
						rel: 'canonical',
						href: 'https://www.pixtar.ae/services',
					});
				}
			} else if (response.body.code == 400) {
			} else {
			}
		});
	}
	navigateToLink(data: any) {
		this.router.navigate([data]);
	}
}
